/**
 * @author Vikrant.
 * @since 23-05-2025.
 * @type {string} Notification action types.
 */

export const SET_LOADING = "[NOTIFICATION] SET_LOADING";
